// Shared table styling for the Phase-2 ranked / chain / by_expiry renderers —
// dense, monospace-numeric, hairline row separators, in app text tokens. Kept
// in one place so the three tables read identically without re-declaring the sx.

import { SxProps, Theme } from '@mui/material';

import { tokens } from '../../../styles/tokens';

const MONO = 'ui-monospace, Menlo, Consolas, monospace';

// The app's themed scrollbar (thumb/track from the scrollbar tokens) — apply to
// any scroll region so it never falls back to the OS's white native bar. Covers
// both Firefox (scrollbar-color) and WebKit. Spread onto a scrollable Box's sx.
export const themedScrollbarSx: SxProps<Theme> = {
  scrollbarWidth: 'thin',
  scrollbarColor: `${tokens.scrollbar.thumb} ${tokens.scrollbar.track}`,
  '&::-webkit-scrollbar': { width: 8, height: 8 },
  '&::-webkit-scrollbar-thumb': { backgroundColor: tokens.scrollbar.thumb, borderRadius: 4 },
  '&::-webkit-scrollbar-track': { backgroundColor: tokens.scrollbar.track },
};

export const flowTableSx: SxProps<Theme> = {
  width: '100%',
  borderCollapse: 'collapse',
  // Value cells one tier up (William's review: numbers were too small); headers
  // stay small. Row padding tightened so the table stays dense despite bigger text.
  fontSize: 12,
};

export const thSx: SxProps<Theme> = {
  color: tokens.text.muted,
  fontWeight: 600,
  textAlign: 'left',
  fontSize: 9.5,
  textTransform: 'uppercase',
  letterSpacing: '0.4px',
  padding: '3px 6px',
  borderBottom: `1px solid ${tokens.border.subtle}`,
};

export const thNumSx: SxProps<Theme> = { ...thSx, textAlign: 'right' };

export const tdSx: SxProps<Theme> = {
  padding: '2px 6px',
  borderBottom: `1px solid ${tokens.border.default}`,
  color: tokens.text.primary,
};

export const tdMonoSx: SxProps<Theme> = { ...tdSx, fontFamily: MONO };

export const tdNumSx: SxProps<Theme> = {
  ...tdSx,
  fontFamily: MONO,
  textAlign: 'right',
  fontWeight: 600,
};

export const tdRankSx: SxProps<Theme> = { ...tdSx, fontFamily: MONO, color: tokens.text.muted };

export const tdInstrumentSx: SxProps<Theme> = {
  ...tdSx,
  fontFamily: MONO,
  color: tokens.text.secondary,
  fontSize: 9.5,
};
